import { classNames } from "@indietabletop/appkit";
import { RecipeVariants } from "@vanilla-extract/recipes";
import { ReactNode } from "react";
import { listDivider, listView } from "./style.css";

export function ListView(
  props: {
    items: ReactNode;
    stickyButton?: ReactNode;
    className?: string;
  } & RecipeVariants<typeof listView.items>,
) {
  const { items, isGrid, stickyButton, className } = props;

  return (
    <div className={classNames(className, listView.container)}>
      <div className={listView.items({ isGrid })}>{items}</div>
      {stickyButton && (
        <div className={listView.actions({ hasMaxInlineSize: isGrid })}>{stickyButton}</div>
      )}
    </div>
  );
}

export function ListDivider() {
  return <hr className={listDivider} />;
}
